module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-material-design-for-bootstrap","short_name":"MDB starter","start_url":"/","background_color":"#4B5EB8","theme_color":"#68008C","display":"standalone","icon":"/opt/build/repo/src/images/smil_logo.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
